import { CircularProgress } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';

import styles from './Spinner.module.scss';

type SpinnerProps = {
  className?: string;
  loading: boolean;
  fullWidth?: boolean;
  fullHeight?: boolean;
  children?: ReactNode;
};

export const Spinner: FC<SpinnerProps> = (props) => {
  const { className, loading, fullWidth = true, fullHeight = true, children } = props;

  return loading ? (
    <div
      className={classNames(styles.root, { [styles.fullWidth]: fullWidth, [styles.fullHeight]: fullHeight }, className)}
    >
      <CircularProgress />
    </div>
  ) : (
    <>{children}</>
  );
};
